/** API route map: URLS.Controller.TimeSheet */
export const TimeSheet = {
      Name: 'TimeSheet/',
      UploadTimeSheet: 'upload-time-sheet',
      GetAllTimeSheet: 'get-all-timesheet',
      GetDistinctEmployee: 'get-all-employee-timesheet',
      GetEmployeeById: 'get-employee-by-id',
      AddTimeSheet: 'add-time-sheet',
      // GetSampleFile: 'download-file',
      GetAllTimeSheetByDate: 'get-all-timesheet-by-date',
      CheckTimeSheet: 'check-time-sheet',
      GetTimeSheetDetails: 'get-timesheet-details',
      GetInvoiceDetails: 'get-invoice-details',
      AddTimeSheetConfiguration: 'add-timesheet-configuration',
      GetTimeSheetConfiguration: 'get-timesheet-configuration',
      GetTimeSheetConfigurationByTimesheet: 'get-timesheet-configuration-by-timesheet',
      CheckPayrollExist: 'check-paygroup-exist',
      CheckEmployeeExistPaygroup: 'check-employee-exist-paygroup',
      CheckTimesheetInprocess: 'check-timesheet-inprocess',
      GetTimeSheet: 'get-all-timesheets',
      CheckTimeSheetCustom: 'check-time-sheet-custom',
      UploadTimeSheetCustom: 'upload-time-sheet-custom',
      CheckTimeSheetSpecial: 'check-time-sheet-special',
      UploadTimeSheetSpecial: 'upload-time-sheet-special',
      UploadStraightHours: 'upload-straight-hours',
      UploadSpecialStraightHours: 'upload-special-straight-hours',
      UploadCustomStraightHours: 'upload-custom-straight-hours',
};
